export const signatureSelectTestIds = {
  select: 'signature-select',
};
